import { render, staticRenderFns } from "./SpinnerWheel.vue?vue&type=template&id=a8d5d37c&scoped=true"
import script from "./SpinnerWheel.vue?vue&type=script&lang=js"
export * from "./SpinnerWheel.vue?vue&type=script&lang=js"
import style0 from "./SpinnerWheel.vue?vue&type=style&index=0&id=a8d5d37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d5d37c",
  null
  
)

export default component.exports